import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';
import { AxiosError } from 'axios';

// Fetch my visit reports
export const fetchMyVisitReports = createAsyncThunk(
  'visitReports/fetchMy',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/visit-reports/my');
      return response.data.data;
    } catch (error) {
      const err = error as AxiosError<{ message: string }>;
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch visit reports');
    }
  }
);

// Fetch visit report by ID
export const fetchVisitReportById = createAsyncThunk(
  'visitReports/fetchById',
  async (reportId: number, { rejectWithValue }) => {
    try {
      const response = await api.get(`/visit-reports/${reportId}`);
      return response.data.data;
    } catch (error) {
      const err = error as AxiosError<{ message: string }>;
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch visit report');
    }
  }
);

// Fetch visit reports by officer ID
export const fetchVisitReportsByOfficer = createAsyncThunk(
  'visitReports/fetchByOfficer',
  async (officerId: number, { rejectWithValue }) => {
    try {
      const response = await api.get(`/visit-reports/officer/${officerId}`);
      return response.data.data;
    } catch (error) {
      const err = error as AxiosError<{ message: string }>;
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch visit reports');
    }
  }
);

const initialState = {
  reports: [],
  currentReport: null,
  loading: false,
  error: null as string | null,
};

const visitReportSlice = createSlice({
  name: 'visitReport',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentReport: (state) => {
      state.currentReport = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch my visit reports
      .addCase(fetchMyVisitReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyVisitReports.fulfilled, (state, action) => {
        state.loading = false;
        state.reports = action.payload;
      })
      .addCase(fetchMyVisitReports.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string | null;
      })
      // Fetch visit report by ID
      .addCase(fetchVisitReportById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVisitReportById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentReport = action.payload;
      })
      .addCase(fetchVisitReportById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string | null;
      })
      // Fetch visit reports by officer
      .addCase(fetchVisitReportsByOfficer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVisitReportsByOfficer.fulfilled, (state, action) => {
        state.loading = false;
        state.reports = action.payload;
      })
      .addCase(fetchVisitReportsByOfficer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string | null;
      });
  },
});

export const { clearError, clearCurrentReport } = visitReportSlice.actions;
export default visitReportSlice.reducer;